import React from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import {QcJobStatusIndicatorStateItem} from './JobStatusIndicatorTypes';

interface JobStatusIndicatorProps {
    statusValue: QcJobStatusIndicatorStateItem | null;
    tabType: string;
}

export default function JobStatusIndicator(props: JobStatusIndicatorProps) {
    const {statusValue, tabType} = props;
    
    return getStatusIcon(statusValue, tabType);
}

export const getStatusIcon = (statusObj: QcJobStatusIndicatorStateItem | null, tabType: string) => {
    if (!statusObj)
        return <></>;
    
    const {status} = statusObj;
    
    switch(status) {
    case 'PENDING':
        return (
            <div>
                {tabType}
                <FiberManualRecordIcon
                    className="pending-status"
                />
            </div>
        );
    case 'PASSED':
        return (
            <div>
                {tabType}
                <FiberManualRecordIcon
                    className="passed-status"
                />
            </div>
        );
    case 'FAILED':
        return (
            <div>
                {tabType}
                <FiberManualRecordIcon
                    className="failed-status"
                />
            </div>
        );
    case 'WARNING':
        return (
            <div>
                {tabType}
                <FiberManualRecordIcon
                    className="warning-status"
                />
            </div>
        );
    default:
        return null;
    }
};
